import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

/**
 * Reusable dialog shown when the user is attempting an action on a non-latest
 * version of a code group.  The caller is responsible for providing the
 * confirmation callback (`onConfirm`) which may perform navigation or resume
 * whatever operation triggered the prompt.
 *
 * Props:
 *  - open: boolean
 *  - message?: string  // custom prompt text
 *  - onClose: () => void
 *  - onConfirm: () => void
 */
export default function LatestVersionDialog({
  open,
  message,
  onClose,
  onConfirm,
}) {
  const defaultMessage =
    "This is not the latest version of the group. Do you want to continue?";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Action</DialogTitle>
      <DialogContent>
        <Typography>{message || defaultMessage}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="button2025RebrandSecondary"
          onClick={onClose}
        >
          No
        </Button>
        <Button
          variant="contained"
          color="button2025RebrandPrimary"
          onClick={onConfirm}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
